export enum OfficeAppType {
    Outlook = 'OUTLOOK',
    Word = 'WORD',
    Excel = 'EXCEL',
    PowerPoint = 'POWER_POINT',
}
